var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFantom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4375 6.07812L9.25 4.4375V7.71875L6.4375 6.07812ZM9.25 13.1094L5.5 15.2969L1.75 13.1094V9.28125L5.5 11.4687L9.25 9.28125V13.1094ZM1.75 4.4375L4.5625 6.07812L1.75 7.71875V4.4375ZM5.96875 6.85937L8.78125 8.5L5.96875 10.1406V6.85937ZM5.03125 10.1406L2.21875 8.5L5.03125 6.85937V10.1406ZM8.78125 3.65625L5.5 5.53125L2.21875 3.65625L5.5 1.70313L8.78125 3.65625ZM0.8125 3.34375V13.5781L5.5 16.2344L10.1875 13.5781V3.34375L5.5 0.6875L0.8125 3.34375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantom);
export default __webpack_public_path__ + "static/media/fantom.d424ca5f.svg";
export { ForwardRef as ReactComponent };